import { IconButton, Typography } from '@pocketlaw/tetris';
import styled from 'styled-components';
import { ICON_CONTAINER_WIDTH, TRANSITION_SETTINGS } from '../config';
export const FadeOutContainer = styled.div `
  display: ${({ $logotype }) => ($logotype ? 'grid' : 'flex')};
  justify-content: start;
  align-items: center;
  width: 100%;
  opacity: 1;
  overflow: hidden;
  white-space: nowrap;

  transition: all ${TRANSITION_SETTINGS};

  ${({ $minimized }) => $minimized &&
    `
    width: 0;
    opacity: 0;
  `};
`;
export const FadeOutSpacer = styled.div `
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1 1 auto;
`;
export const StyledIconButton = styled(IconButton) `
  width: ${ICON_CONTAINER_WIDTH};
  height: ${ICON_CONTAINER_WIDTH};
  flex-shrink: 0;
`;
export const IconContainer = styled.div `
  min-width: ${ICON_CONTAINER_WIDTH};
  height: ${ICON_CONTAINER_WIDTH};
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;
export const StyledOverflowTypography = styled(Typography) `
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;
